var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTick = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "2F3DB1FF-A232-4810-A9AE-7D85DA0878CE")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Sucesso-/-Modal-/-Tablet",
    transform: "translate(-22.000000, -26.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(22.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C11.1928867,0 0,11.1928867 0,25 C0,38.8071133 11.1928867,50 25,50 C38.8071133,50 50,38.8071133 50,25 C49.9853515,11.19906 38.8010446,0.0147530898 25,0 Z M25,46.4286013 C13.1653016,46.4286013 3.57139868,36.8346984 3.57139868,25 C3.57139868,13.1653016 13.1653016,3.57139868 25,3.57139868 C36.8346984,3.57139868 46.4286013,13.1653016 46.4286013,25 C46.4158362,36.8294668 36.8294668,46.4158362 25,46.4286013 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4466282,15.4917779 C37.7442137,14.836074 36.6306945,14.836074 35.9283862,15.4917779 L19.0847751,31.7714644 L13.1161634,26.0026456 C12.4207582,25.3067044 11.2732546,25.2875095 10.5533169,25.9596368 C9.83327298,26.6317641 9.81341336,27.7408562 10.5088186,28.4366948 C10.5233682,28.4512706 10.5382363,28.465641 10.5533169,28.4797035 L17.8033518,35.4870513 C18.5110764,36.1709829 19.6584738,36.1709829 20.3661984,35.4870513 L38.4912327,17.9687332 C39.1866379,17.2728947 39.1666721,16.1639052 38.4466282,15.4917779 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick.97198272.svg";
export { ForwardRef as ReactComponent };